export var MIN_OMITTABLE_TIME_RANGE = 60 * 24 * 3600 * 1000; // отбрасываем события старше 60 дней
export var DEFAULT_ID_STORAGE_DURATION = (5 * 365 * 24 * 3600); // 5 лет
// В соответсвии с https://fetch.spec.whatwg.org/ лимит на отправку данных через keepalive равен 64 kibibytes
// Поэтому отправляем данные по достижении 50% от предельного количества данных
export var DEFAULT_EVENTS_JSON_SIZE_LIMIT = 32 * 1000;
//# sourceMappingURL=settings.js.map